<div class="footer flex flex-col items-center justify-center text-center">
  <div class="flex flex-col sm:flex-row items-center justify-center container mx-auto gap-2">
    <a class="action flex-none" color="primary" href="https://www.wgi.ai/contact" mat-flat-button target="_blank"
      rel="noopener">
      <mat-icon class="icon-sm mr-2" svgIcon="mat:mail"></mat-icon>
      <span>Contact Us</span>
    </a>
    <div class="font-medium flex flex-wrap items-center justify-center gap-2">
      <span class="text-secondary">© {{ currentYear }} Bigspark, Inc. All rights reserved.</span>
      <span class="text-secondary">|</span>
      <a class="text-secondary" [routerLink]="['/privacy-policy']">Privacy Policy</a>
      <span class="text-secondary">|</span>
      <a class="text-secondary" [routerLink]="['/terms-and-conditions']">Terms of Use
        </a>

      <span class="text-secondary">|</span>
      <a class="text-secondary" href="https://www.bigspark.ai/cookie" target="_blank" rel="noopener">Cookie Policy</a>
    </div>
  </div>
</div>